import { Box, Card, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FormType } from '@/api/enum/formType.enum';
import { useState } from 'react';
import AboutUsInfoForm from './components/RegularMonthInfoForm';

export default function RegularMonthCreatePage() {
	const { t } = useTranslation();
	const [type, setType] = useState<FormType>(FormType.create);
	return (
		<>
			<Box sx={{ width: '100%' }}>
				<Box>
					<Typography variant='h4'>
						{t('drawerListItems.addRegularMonthTask')}
					</Typography>
					<Card sx={{ marginTop: 3 }}>
						<AboutUsInfoForm type={type} setType={setType} />
					</Card>
				</Box>
			</Box>
		</>
	);
}
